module.exports = __webpack_public_path__ + "static/media/logo.49dbdbb2.jpg";